import React from "react";
import {
  getVendorDealTitleParts,
  shortenProductLabel,
} from "../../utils/productLabels";

const VendorDealTitle = ({
  deal,
  headlineClassName = "text-sm font-medium text-gray-900",
  sublineClassName = "mt-0.5 text-xs text-gray-500 truncate max-w-[12rem] sm:max-w-[16rem]",
  productNameMaxLength = 32,
  shortenProductName = true,
  as: Wrapper = "div",
}) => {
  const { headline, subline, showSubline } = getVendorDealTitleParts(deal);
  const displayProductName =
    shortenProductName && Number.isFinite(productNameMaxLength)
      ? shortenProductLabel(subline, productNameMaxLength)
      : subline;

  return (
    <Wrapper>
      <div className={headlineClassName}>{headline}</div>
      {showSubline && (
        <div
          className={sublineClassName}
          title={displayProductName !== subline ? subline : undefined}
        >
          {displayProductName}
        </div>
      )}
    </Wrapper>
  );
};

export default VendorDealTitle;
